"use strict";

window.FoG = window.FoG || {};

window.FoG.TweetableBlockquotes = (function($) {
  function init() {
    $('.main-article blockquote:not(.twitter-tweet):not(.plain)').each((idx, el) => {
      var $blockquote = $(el);
      var text = $blockquote.text();
      var url = [location.protocol, '//', location.host, location.pathname].join('');
      var tweetUri = 'https://twitter.com/intent/tweet?text=' + encodeURI(text) + " \n" + url;

      
      var tweetLink = $('<a></a>')
        .attr('href', tweetUri)
        .attr('title', 'Tweet This')
        .attr('rel', 'noopener')
        .attr('target', '_blank')
        .addClass('fab fa-twitter')
        .append('<label>Tweet This</label>');

      var target = $blockquote.children().last() || $blockquote;
      target.append(tweetLink);
    });
  }
  
  $(init);
})(jQuery);
